import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { CustomAutoComplete } from "../../../../../../components/input/CustomAutoComplete";
import { TRIP_TYPE } from "../../../../../../constants";
import { FormProvider, useFormContext } from "react-hook-form";
import { AddEmissionContext } from "../../../../../../contexts/AddEmissionContext";
import { common, input } from "../../../../../../i18n";
import { NumericField } from "../../../../../../components/input/NumericField";

const AddEmployeeCommuting = () => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  const { isDisabledAuxInput } = AddEmissionContext();

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <NumericField
          size="small"
          name="amount"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          disabled
          label={t("input-amount-of-distance")}
          placeholder={t("to-be-calculated")}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <CustomAutoComplete
          name="aux1"
          required={!isDisabledAuxInput}
          label={t("trip-type")}
          info={t("trip-type")}
          control={stepTwoForm.control}
          listMenuItem={TRIP_TYPE}
          placeholder={t("Select-Param", {
            param: t("trip-type"),
          })}
          rules={
            isDisabledAuxInput
              ? undefined
              : {
                  required: t("This-field-is-required", {
                    param: t("trip-type"),
                  }),
                }
          }
          defaultValue={null}
          disabled={isDisabledAuxInput}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux2"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("Distance-(One-way)")}
          placeholder={t("Distance-(One-way)")}
          fullWidth
          disabled={isDisabledAuxInput}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux3"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={0}
          label={t("Amount-Of-Employees")}
          placeholder={t("Amount-Of-Employees")}
          fullWidth
          disabled={isDisabledAuxInput}
        />
      </Grid>
    </FormProvider>
  );
};

export default AddEmployeeCommuting;
